import { Component, inject } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { HttpLoadingService } from '@common/app/services/http-loading.service';

@Component({
  selector: 'eq-http-loading-overlay',
  standalone: true,
  imports: [ProgressSpinnerModule],
  template: `
    @if (loading.loading()) {
      <div class="http-loading-overlay" aria-live="polite" aria-busy="true">
        <p-progressSpinner strokeWidth="4" ariaLabel="Carregando" />
      </div>
    }
  `,
  styleUrl: './http-loading-overlay.component.scss',
})
export class HttpLoadingOverlayComponent {
  readonly loading = inject(HttpLoadingService);
}
